import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { RoutingService } from '@app/core/services/routing.service';

@Injectable({ providedIn: 'root' })
export class PersonalizationPageResolver implements Resolve<any> {
  constructor(private routingService: RoutingService) {}

  resolve(route: ActivatedRouteSnapshot, _state: RouterStateSnapshot) {
    if (!route.queryParams?.webview) {
      this.routingService.redirectTo('/we-love/', { openPersonalization: true });
    }
  }
}
